





















































import { Component, Vue } from 'vue-property-decorator'
import { TeacherTypeController } from '@/services/request.service'
import TeacherTypeEditor from './components/TeacherTypeEditor.vue'
import FlexTooltip from '@/components/FlexTooltip.vue'
import { i18n } from '@/i18n/i18n'
import { toPage } from '@/utils/utils'
import { createPagination } from '@/constant/constant'

@Component({
  components: {
    TeacherTypeEditor,
    FlexTooltip,
  },
})
export default class TeacherType extends Vue {
  private loading: boolean = false
  private editorType = ''
  private editorVisible = false
  private teacherInfo: any = {}
  private data: Array<any> = []
  private pagination: any = createPagination({
    showTotal: total => i18n.tc('common.pageTotal', total, { total }),
  })

  private teacherType: any = {}
  private get columns(): Array<any> {
    return [
      {
        key: 'name',
        title: this.$t('setup.teacherType'),
        align: 'left',
        scopedSlots: { customRender: 'name' },
      },
      {
        key: 'operations',
        title: this.$t('common.operations'),
        align: 'left',
        scopedSlots: { customRender: 'operations' },
      },
    ]
  }

  private created(): void {
    this.getData()
  }

  private get locale(): string {
    return this.$store.state.locale
  }

  private getData(page = { current: 1, pageSize: this.pagination.defaultPageSize }): void {
    this.loading = true
    this.data = []
    TeacherTypeController.getList({ pageCurrent: page.current, pageSize: page.pageSize })
      .then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.totalItem
        this.pagination.current = page.current
        toPage(page, this.data, page => {
          this.pagination.current = page
          this.refresh()
        })
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private handleTableChange(pagination): void {
    this.$set(this.pagination, 'current', pagination.current)
    this.$set(this.pagination, 'pageSize', pagination.pageSize)
    this.getData(pagination)
  }

  private addTeacherType(): void {
    this.editorType = 'addTeacherType'
    this.editorVisible = true
    this.teacherType = {}
  }

  private edit(id): void {
    this.editorType = 'editTeacherType'
    this.editorVisible = true
    this.teacherType = this.data.filter(item => item.teacherTypeId === id)[0]
  }

  private deleteRecord(id): void {
    TeacherTypeController.delete(id)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.refresh()
      })
  }

  private refresh(): void {
    this.getData(this.pagination)
  }
}
